module.exports = __webpack_public_path__ + "static/media/support6.d45a5820.png";